import React, { useRef, useEffect, useState } from "react";
// import * as handTrack from "handtrackjs";
import useStore, { startTimer } from "../../store/store";
import Webcam from "react-webcam";
import Sound from "react-sound";
import { drawResult, getMainZones } from "../../utils";
import * as handPoseDetection from "@tensorflow-models/hand-pose-detection";
import Button from "../../components/Button";
import right from "../../assets/right.png";
import top from "../../assets/top.png";
import left from "../../assets/left.png";
import bottom from "../../assets/bottom.png";
import flesh from "../../assets/flesh.png";
import goute_left from "../../assets/goute_left.png";
import goute_right from "../../assets/goute_right.png";
import goute_both from "../../assets/both.png";
import check from "../../assets/check.png";
import check_flip from "../../assets/check_fliped.png";
import sound from "../../assets/bg_music.mp3";
import { FiVolume, FiVolume2, FiVolumeX } from "react-icons/fi";

const detectorConfig = {
  runtime: "mediapipe", // or 'tfjs'
  solutionPath: "https://cdn.jsdelivr.net/npm/@mediapipe/hands",
  modelType: "full",
};

const module = handPoseDetection.SupportedModels.MediaPipeHands;

const CreamApplay = () => {
  const canvasRef = useRef(null);
  const canvasRefRes = useRef(null);
  const boxRef = useRef(null);
  const camRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [volume, setVolume] = useState(99);
  const {
    picData,
    predictions,
    hittedZone,
    inGameTimer,
    timerStarted,
    mainZones,
    ready,
    setReady,
    setTimerStarted,
    rightZoneOk,
    leftZoneOk,
    topZoneOk,
    bottomZoneOk,
    topZoneChecked,
    bottomZoneChecked,
    leftZoneChecked,
    rightZoneChecked,
  } = useStore();
  const [size, setSize] = useState({
    height: 0,
    width: 0,
    setted: false,
  });

  const runHandpose = async () => {
    setLoader(true);
    console.info("Handpose model loading...");
    const net = await handPoseDetection.createDetector(module, detectorConfig);
    setLoader(false);

    setInterval(() => {
      if (net) {
        detect(net);
      }
    }, 50);
  };

  const detect = async (net) => {
    // Check data is available
    if (
      typeof camRef.current !== "undefined" &&
      camRef.current !== null &&
      camRef.current.video.readyState === 4
    ) {
      startTimer();
      setReady(true);
      // setTimerStarted(true)
      // Get Video Properties
      const video = camRef.current.video;
      const videoWidth = camRef.current.video.videoWidth;
      const videoHeight = camRef.current.video.videoHeight;

      // Set video width
      camRef.current.video.width = videoWidth;
      camRef.current.video.height = videoHeight;

      // Set canvas height and width
      canvasRefRes.current.width = videoWidth;
      canvasRefRes.current.height = videoHeight;

      // rotate !

      video.style.transform = "rotate(180deg)";

      // Make Detections
      const hand = await net.estimateHands(video);

      // Draw mesh
      const ctx = canvasRefRes.current.getContext("2d");
      // ctx.save();
      // ctx.scale(-1, 1);

      if (hand.length > 0) {
        const faceBox = predictions.filter((x) => x.label === "face")[0].bbox;
        drawResult(
          hand,
          {
            x: faceBox[0],
            y: faceBox[1],
            w: faceBox[2],
            h: faceBox[0],
          },
          ctx
        );
      }
    }
  };

  useEffect(() => {
    if (canvasRef.current) {
      //call its drawImage() function passing it the source canvas directly
      const ima = new Image();
      ima.src = picData;
      const ratio = ima.naturalHeight / ima.naturalWidth;
      const boxHeight = boxRef.current.clientHeight;
      const targetWidth = Math.round(boxHeight * ratio);
      setSize({
        height: ima.naturalHeight,
        width: ima.naturalWidth,
        setted: true,
      });
    }
  }, [canvasRef, picData]);

  useEffect(() => {
    if (size.setted) {
      const ima = new Image();
      ima.src = picData;
      const facePredection = predictions.filter((x) => x.label === "face")[0];
      const faceBox = facePredection.bbox;
      var destCtx = canvasRef.current.getContext("2d");
      // flip the image
      destCtx.save();
      destCtx.scale(-1, 1);
      destCtx.drawImage(ima, 0, 0, size.width * -1, size.height);
      destCtx.restore();
      // draw the face bounding box
      destCtx.beginPath();
      destCtx.setLineDash([20, 5]);
      destCtx.rect(faceBox[0], faceBox[1], faceBox[2], faceBox[3]);
      destCtx.strokeStyle = "white";
      destCtx.lineWidth = 3;
      destCtx.stroke();

      // draw the face result on the canvas
      if (!ready) {
        destCtx.save();
        destCtx.scale(-1, 1);
        destCtx.fillStyle = "white";
        destCtx.font = "20px Comic Sans MS";
        destCtx.fillText(
          `${facePredection.score} | ${facePredection.label}`,
          faceBox[0],
          faceBox[1] - 20
        );
        destCtx.restore();
      }
    }
  }, [size.setted, ready]);

  useEffect(() => {
    if (timerStarted) {
      var destCtx = canvasRef.current.getContext("2d");
      mainZones.forEach((zone) => {
        let imageToDraw =
          zone.key === "right"
            ? right
            : zone.key === "left"
            ? left
            : zone.key === "top"
            ? top
            : zone.key === "bottom"
            ? bottom
            : null;
        // decide if we need goute for success
        if (topZoneOk || bottomZoneOk || leftZoneOk || rightZoneOk) {
          // clear and redraw static parts
          const ima = new Image();
          ima.src = picData;
          const facePredection = predictions.filter(
            (x) => x.label === "face"
          )[0];
          const faceBox = facePredection.bbox;
          destCtx.clearRect(
            0,
            0,
            canvasRef.current.width,
            canvasRef.current.height
          );
          // flip the image
          destCtx.save();
          destCtx.scale(-1, 1);
          destCtx.drawImage(ima, 0, 0, size.width * -1, size.height);
          destCtx.restore();
          // draw the face bounding box
          destCtx.beginPath();
          destCtx.setLineDash([20, 5]);
          destCtx.rect(faceBox[0], faceBox[1], faceBox[2], faceBox[3]);
          destCtx.strokeStyle = "white";
          destCtx.lineWidth = 3;
          destCtx.stroke();
          if (zone.key === "right" && rightZoneOk) {
            // clear the zone
            // destCtx.clearRect(zone.x, zone.y, zone.w, zone.h);
            if (rightZoneChecked) {
              imageToDraw = check;
            } else {
              imageToDraw = goute_right;
            }
          } else if (zone.key === "left" && leftZoneOk) {
            // destCtx.clearRect(zone.x, zone.y, zone.w, zone.h);
            if (leftZoneChecked) {
              imageToDraw = check_flip;
            } else {
              imageToDraw = goute_left;
            }
          } else if (zone.key === "top" && topZoneOk) {
            // destCtx.clearRect(zone.x, zone.y, zone.w, zone.h);
            if (topZoneChecked) {
              imageToDraw = check;
            } else {
              imageToDraw = goute_both;
            }
          } else if (zone.key === "bottom" && bottomZoneOk) {
            if (bottomZoneChecked) {
              imageToDraw = check;
            } else {
              imageToDraw = goute_both;
            }
          }
          // destCtx.clearRect(zone.x, zone.y, zone.w, zone.h);
        }

        let imgTemp = new Image();
        imgTemp.onload = () => {
          destCtx.drawImage(imgTemp, zone.x, zone.y, zone.w, zone.h);
          // for test only
          // destCtx.beginPath();
          // destCtx.rect(zone.x, zone.y, zone.w, zone.h);
          // destCtx.strokeStyle = "white";
          // destCtx.lineWidth = 2;
          // destCtx.stroke();
          // end for test only
        };
        imgTemp.onerror = () => {
          console.log("error loading image !!!");
        };
        imgTemp.src = imageToDraw; // applay zone
        // destCtx.drawImage(imgTemp, zone.x, zone.y, zone.w, zone.h);
      });
    }
  }, [timerStarted, bottomZoneOk, leftZoneOk, rightZoneOk, topZoneOk, leftZoneChecked, rightZoneChecked, topZoneChecked, bottomZoneChecked]);

  return (
    <div className="flex flex-col justify-start content-center h-full w-full light-overlay">
      <Sound
        url={sound}
        volume={volume}
        onFinishedPlaying={() => {}} // replay the sound
        playStatus={Sound.status.PLAYING}
      />
      <div className="flex flex-col w-full fixed-area" ref={boxRef}>
        <Webcam
          ref={camRef}
          className="w-full h-full absolute top-0 left-0 bottom-0 right-0"
          mirrored={false}
          videoConstraints={{
            facingMode: "user",
            width: 640,
            height: 480,
          }}
          style={{
            // position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            left: 0,
            // right: 0,
            top: 0,
            bottom: 0,
            textAlign: "center",
            zindex: 9,
            // transform: 'scale(-1, 1)',
            // width: 640,
            // height: 480,
            // zoom: 2,
            // zIndex: 9,
            opacity: 0,
          }}
        />

        <canvas
          ref={canvasRef}
          className="w-full"
          height={size.height}
          width={size.width}
          style={{
            position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "auto",
            marginBottom: "auto",
            left: 0,
            right: 0,
            textAlign: "center",
            zindex: 9,
            transform: "scale(-1, 1)",
            // filter: 'FlipH'
            // width: 640,
            // height: 480,
          }}
        />
        <canvas
          ref={canvasRefRes}
          className="w-full"
          height={size.height}
          width={size.width}
          style={{
            position: "absolute",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "auto",
            marginBottom: "auto",
            left: 0,
            right: 0,
            textAlign: "center",
            zindex: 9,
            transform: "scale(-1, 1)",
            // filter: 'FlipH'
            // width: 640,
            // height: 480,
          }}
        />
      </div>
      <div className="rounded-t-3xl bg-primary py-9 px-6 flex flex-col flex-grow justify-center">
        {!ready && (
          <div className="flex flex-row">
            <Button
              type="secondary"
              className="drop-shadow-lg"
              onClick={runHandpose}
              disabled={ready}
            >
              APPLIQUEZ LA CRÈME
            </Button>
          </div>
        )}
        {ready && (
          <div className="flex flex-col">
            {/* <span>{inGameTimer}</span>
            <p>
              <span>b: {hittedZone.filter((x) => x === "bottom").length}</span>
              <span>t: {hittedZone.filter((x) => x === "top").length}</span>
              <span>l: {hittedZone.filter((x) => x === "left").length}</span>
              <span>r: {hittedZone.filter((x) => x === "right").length}</span>
            </p> */}
            <div className="flex flex-row justify-between align-middle items-center">
              <div className="flex flex-row justify-center items-start">
                <label htmlFor="volume_btn" className="text-white my-auto">
                  Music
                </label>
                <Button
                  onClick={() => setVolume(volume > 0 ? 0 : 99)}
                  className="ml-1 pl-1"
                  id="volume_btn"
                >
                  {volume > 0 ? <FiVolume2 /> : <FiVolumeX />}
                </Button>
              </div>
              <p className="font-extrabold text-center uppercase text-white">
                Reste <span className="text-2xl">{inGameTimer}</span>s
              </p>
            </div>
            <p className="text-2xl font-extrabold text-left uppercase text-white">
              SUIVEZ LE SENS{" "}
            </p>
            <div className="flex flex-row">
              <img src={flesh} alt="flesh" />
            </div>
          </div>
        )}
      </div>
      {!ready && loader && (
        <div className="absolute top-0 bottom-0 left-0 right-0 bg-opacity-70 bg-slate-500">
          <div className="flex justify-center items-center h-full w-full">
            <div role="status">
              <svg
                className="inline mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-yellow-400"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreamApplay;
